import { useEffect, useState } from "react";
import { collection, doc, onSnapshot, query, where, serverTimestamp, deleteDoc, addDoc } from "firebase/firestore";
import { db } from "../firebase";
import { S, C } from "../ui";
import { TRADES } from "../constants";

// Generalizes CustodialView's per-room QR concept to equipment (spec
// section 2, Asset entity) — asset_type is "room" or "equipment", tagged
// with a trade so the field flow knows which checklist template applies.
export default function AssetsPanel({ facilityId }) {
  const [assets, setAssets] = useState([]);
  const [adding, setAdding] = useState(false);
  const [name, setName] = useState("");
  const [trade, setTrade] = useState(TRADES[0]);
  const [assetType, setAssetType] = useState("room");
  const [err, setErr] = useState("");

  useEffect(() => onSnapshot(query(collection(db, "assets"), where("facilityId", "==", facilityId)), s =>
    setAssets(s.docs.map(d => ({ id: d.id, ...d.data() })))), [facilityId]);

  const addAsset = async () => {
    if (!name.trim()) { setErr("Enter a name."); return; }
    setErr("");
    try {
      await addDoc(collection(db, "assets"), {
        facilityId, name: name.trim(), trade, assetType, createdAt: serverTimestamp(),
      });
      setName(""); setAdding(false);
    } catch (e) {
      setErr("Couldn't add asset — try again.");
    }
  };

  const removeAsset = (id) => deleteDoc(doc(db, "assets", id));

  const qrUrl = (assetId) => `${window.location.origin}/?facilityId=${facilityId}&assetId=${assetId}`;

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <div style={{ fontSize: 13, color: C.muted }}>Rooms and equipment workers scan a QR code to document.</div>
        <button style={{ ...S.btn(), width: "auto", padding: "10px 18px" }} onClick={() => setAdding(a => !a)}>{adding ? "Cancel" : "+ Add Asset"}</button>
      </div>

      {adding && (
        <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: 0, padding: 16, marginBottom: 20, maxWidth: 420 }}>
          {err && <div style={S.err}>{err}</div>}
          <input style={S.input} placeholder="Name (e.g. Rooftop HVAC Unit 2, Lobby)" value={name} onChange={e => setName(e.target.value)} autoFocus />
          <select style={{ ...S.input, background: C.white }} value={assetType} onChange={e => setAssetType(e.target.value)}>
            <option value="room">Room</option>
            <option value="equipment">Equipment</option>
          </select>
          <select style={{ ...S.input, background: C.white }} value={trade} onChange={e => setTrade(e.target.value)}>
            {TRADES.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
          <button style={S.btn(C.green)} onClick={addAsset}>Add Asset</button>
        </div>
      )}

      <div style={{ background: C.white, borderRadius: 0, border: `1px solid ${C.border}`, overflow: "hidden" }}>
        {assets.length === 0 && (
          <div style={{ padding: 24, textAlign: "center", color: C.muted, fontSize: 13 }}>No assets yet.</div>
        )}
        {assets.map((a, idx) => (
          <div key={a.id} style={{ padding: "14px 16px", borderBottom: idx === assets.length - 1 ? "none" : `1px solid ${C.border}`, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600 }}>{a.name}</div>
              <div style={{ fontSize: 12, color: C.muted, textTransform: "capitalize" }}>{a.assetType} · {a.trade}</div>
            </div>
            <a href={qrUrl(a.id)} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: C.accent, textDecoration: "none" }}>Test link →</a>
            <button onClick={() => removeAsset(a.id)} className="icon-tap-target" style={S.iconBtn}>×</button>
          </div>
        ))}
      </div>
    </div>
  );
}
